import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { Logo } from './logo';
import { UserLoginData } from './user-short-data';

import styles from './header.module.css';

type HeaderProps = { title: string };
export const Header = observer(({ title }: HeaderProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.logo}>
        <Link to="/">
          <Logo />
        </Link>
      </div>

      <div className={styles.titleBar}>
        <h1 className={styles.pageHeader}>{title}</h1>
        <UserLoginData />
      </div>
    </div>
  );
});
